import { PayloadAction } from '@reduxjs/toolkit';

import { GridConfigState } from 'editor/src/store/gridConfig/types';

const setGridDesignsLocaleReducer = (state: GridConfigState, action: PayloadAction<string>) => {
  state.locale = action.payload;
};

export default setGridDesignsLocaleReducer;
